module.exports = __webpack_public_path__ + "img/pic_aboutus.115d78bb.png";